/**
 * A custódia vista do exame eletrônico (E136, GUS-152, ADR-0092). Espelha
 * `apps/api/types/ocorrencias_de_custodia.py` (`ObjetoBloqueado`) e
 * `apps/api/types/exame_eletronico_item.py` (`FonteDoEsperado`).
 */

/** E136.F2 (CA08): de onde veio o valor declarado que o item confronta. */
export type FonteDoEsperado = 'protocolo' | 'tela_impressa' | 'perito';

/** E136.F1: um documento que não segue para o exame — o arquivo de que ele depende não confere com o
 * registro do recebimento (ocorrência aberta), ou foi tirado do exame na resolução. */
export interface ObjetoBloqueadoData {
  source_document_id: string;
  objeto_id: string;
  ocorrencia_id: string | null;
  situacao: 'diverge' | 'ausente';
  acao?: 'restaurado' | 'retirado_do_exame' | 'reenviado_pelo_banco' | null;
}

/** As peças paradas do caso; o caso ainda não lido não tem nenhuma. */
export function paradasDoCaso(
  caso: { pecas_paradas_pela_custodia?: ObjetoBloqueadoData[] } | null | undefined,
): ObjetoBloqueadoData[] {
  return caso?.pecas_paradas_pela_custodia ?? [];
}
